module.exports = __webpack_public_path__ + "img/i.299ebbf3.jpg";